<template>
  <div id="Settings">
    <SovecoNavBar />
    <div class="tabs is-boxed is-marginless">
      <ul class="vehicles_top_tabs">
        <li :class="isTabActive(0)" @click="tabNo = 0">
          <a>Password temporanee</a>
        </li>
        <li :class="isTabActive(1)" @click="tabNo = 1">
          <a>Preferenze</a>
        </li>
        <li :class="isTabActive(2)" @click="tabNo = 2">
          <a>Credenziali Servizio Cronotachigrafo</a>
        </li>
        <li :class="isTabActive(3)" @click="tabNo = 3">
          <a>Credenziali Actia</a>
        </li>
        <li :class="isTabActive(4)" @click="tabNo = 4">
          <a>Feedback</a>
        </li>
      </ul>
    </div>
    <template v-if="tabNo === 0">
      <div
        class="columns is-variable is-gapeless is-0"
        style="height: calc(100vh - 95px)"
      >
        <div class="column" style="display: flex; flex-direction: column">
          <div style="overflow-y: auto; max-height: 30vh">
            <VueScrollTable
              :options="passwordOpts"
              :columns="passwordCols"
              :rows="passwordRows"
            />
          </div>
            <div
              class="password_bot_box"
              style="
                display: flex;
                justify-content: center;
                gap: 10px;
                align-items: center;
              "
            >
              <button
                v-if="passwordSel.login_tmp === ''"
                class="button is-danger buttonsize200"
                @click="doDeletePassword"
                disabled
              >
                Elimina Password
              </button>
              <button
                v-else
                class="button is-danger buttonsize200"
                @click="doDeletePassword"
              >
                Elimina Password
              </button>
              <button
                class="button is-success buttonsize200"
                @click="createPassword"
              >
                Crea Password
              </button>
            </div>
            <div class="drivers_scheda_top_box evidencewrite">
              {{ messageScheda }}
            </div>
          <div style="flex: 1; overflow-y: auto">
            <div id="PW02" style="font-size: 0.85rem">
              <div class="drivers_scheda_box">
                <div class="columns is-gapless mb-1">
                  <div class="column">
                    <label class="label is-small mb-1">Login</label>
                    <input
                      v-model="passwordSel.login_tmp"
                      class="input is-small"
                      type="text"
                      placeholder="login"
                    />
                  </div>
                  <div class="column" style="padding-left: 5px">
                    <label class="label is-small mb-1">Password</label>
                    <input
                      v-model="passwordSel.password_chiaro"
                      class="input is-small"
                      type="text"
                      placeholder="password"
                    />
                  </div>
                </div>
                <div class="mb-1">
                  <label class="label is-small mb-1">Nota</label>
                  <input
                    v-model="passwordSel.nota"
                    class="input is-small"
                    type="text"
                    placeholder="nota"
                  />
                </div>
                <div class="columns is-gapless mb-3">
                  <div class="column">
                    <label class="label is-small mb-1">Inizio</label>
                    <date-picker
                      v-model="startdata"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    ></date-picker>
                  </div>
                  <div class="column pl-2">
                    <label class="label is-small mb-1">Fine</label>
                    <date-picker
                      v-model="enddata"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-1">
                  <label class="checkbox is-small">
                    <input
                      v-model="passwordSel.filtro_geografico_attivo"
                      type="checkbox"
                    />
                    Filtro Geografico
                  </label>
                </div>

                <!-- NUOVO: Filtro per Codici Postali -->
                <div class="mb-3" v-if="passwordSel.filtro_geografico_attivo">
                  <label class="label is-small mb-1">
                    <strong>Filtro per Codici Postali</strong>
                  </label>
                  <input
                    v-model="passwordSel.codici_postali"
                    class="input is-small"
                    type="text"
                    placeholder="es. 41030, 41100, 41121"
                  />
                </div>

                <!-- VECCHIO: Filtro per Area Geografica (Retrocompatibilità) -->
                <div
                  v-if="
                    passwordSel.filtro_geografico_attivo &&
                    !passwordSel.codici_postali
                  "
                >
                  <label class="label is-small mb-1">
                    <strong>Filtro per Area Geografica</strong>
                  </label>
                  <div class="columns is-gapless mb-1">
                    <div class="column">
                      <label class="label is-small mb-1">Latitudine</label>
                      <input
                        v-model="passwordSel.latitudine_centro"
                        class="input is-small"
                        type="number"
                        step="0.000001"
                        placeholder="es. 45.464664"
                      />
                    </div>
                    <div class="column pl-2">
                      <label class="label is-small mb-1">Longitudine</label>
                      <input
                        v-model="passwordSel.longitudine_centro"
                        class="input is-small"
                        type="number"
                        step="0.000001"
                        placeholder="es. 9.188540"
                      />
                    </div>
                    <div class="column pl-2">
                      <label class="label is-small mb-1">Raggio (km)</label>
                      <input
                        v-model="passwordSel.raggio_km"
                        class="input is-small"
                        type="number"
                        step="0.1"
                        min="0"
                        placeholder="es. 50"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="drivers_scheda_bot_box"
            style="
              display: flex;
              justify-content: center;
              gap: 10px;
              align-items: center;
            "
          >
            <span class="button is-danger buttonsize200" @click="cancelEntry"
              >Annulla</span
            >
            <span class="button is-success buttonsize200" @click="saveEntry"
              >Salva</span
            >
          </div>
        </div>
        <div
          class="column column-middle"
          style="display: flex; flex-direction: column"
        >
          <div class="table-wrapper" style="flex: 1; overflow: hidden">
            <VueScrollTable
              :options="vehiclesOpts"
              :columns="vehiclesCols"
              :rows="vehiclesRows"
            />
          </div>
          <div
            class="drivers_scheda_bot_box"
            style="
              display: flex;
              justify-content: center;
              gap: 10px;
              align-items: center;
            "
          >
            <span class="button" @click="setSel(true)">Seleziona Tutti</span>
            <span class="button" @click="setSel(false)">Deseleziona Tutti</span>
          </div>
        </div>
        <div class="column" style="display: flex; flex-direction: column">
          <div style="flex: 1; overflow: hidden">
            <VueScrollTable
              :options="vehiclesSelectOpts"
              :columns="vehiclesSelectCols"
              :rows="vehiclesSelectRows"
            />
          </div>
          <div
            class="drivers_scheda_bot_box"
            style="display: flex; justify-content: center; align-items: center"
          >
            <button
              v-if="selectedRow !== null"
              class="button is-danger"
              @click="removeSelected()"
            >
              Rimuovi
            </button>
          </div>
        </div>
      </div>
    </template>

    <template v-if="tabNo === 1">
      <div class="box">
        <article class="media">
          <div class="columns">
            <div class="column">
              <div class="box">
                <div class="media-left">
                  <strong>Storico</strong>
                </div>
                <div class="media-content">
                  <div class="content pref1">
                    <p>
                      <small>preferenze visualizzazione</small>
                      <br />
                    </p>
                    <div class="control">
                      <table class="table">
                        <tr>
                          <td>
                            <label class="radio">
                              <input
                                id="1"
                                v-model="storico"
                                type="radio"
                                value="1"
                              />
                              Visualizza le posizioni dal giorno precedente
                              l'ultima posizione
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="radio">
                              <input
                                id="2"
                                v-model="storico"
                                type="radio"
                                value="2"
                              />
                              Visualizza i viaggi effettuati dal giorno
                              precedente l'ultima posizione
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="media-left">
                  <strong>Pagina Iniziale</strong>
                </div>
                <div class="media-content">
                  <div class="content pref3">
                    <p>
                      <small>visualizzazione</small>
                      <br />
                    </p>
                    <div class="control">
                      <table class="table">
                        <tr>
                          <td>
                            <label class="radio">
                              <input
                                id="1"
                                v-model="landing"
                                type="radio"
                                value="1"
                              />
                              Mappa
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="radio">
                              <input
                                id="2"
                                v-model="landing"
                                type="radio"
                                value="2"
                              />
                              Lista
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="media-left">
                  <strong>Viaggio</strong>
                </div>
                <div class="media-content">
                  <div class="content pref2">
                    <p>
                      <small>identificazione</small>
                      <br />
                    </p>
                    <div class="control">
                      <table>
                        <tr>
                          <td width="130px">
                            <label class="sr_vert_aligner">Sosta minima</label>
                            <div class="field">
                              <div class="control">
                                <input
                                  v-model="sostaMin"
                                  class="input"
                                  type="number"
                                  placeholder="Sosta minima"
                                />
                              </div>
                            </div>
                          </td>

                          <td width="130px">
                            <label class="control">Sosta massima</label>
                            <div class="field">
                              <div class="control">
                                <input
                                  v-model="sostaMax"
                                  class="input"
                                  type="number"
                                  placeholder="Sosta massima"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="box">
                <div class="media-left">
                  <strong>Motrice-Rimorchio</strong>
                </div>
                <div class="media-content">
                  <div class="content pref3">
                    <p>
                      <small>abbinamento</small>
                      <br />
                    </p>
                    <div class="control">
                      <table class="table">
                        <tr>
                          <td width="200px">
                            <label class="radio pt-3">
                              <input
                                id="1"
                                v-model="coupling"
                                type="radio"
                                value="1"
                              />
                              Attivo
                            </label>
                          </td>
                          <td width="200px">
                            <input
                              v-model="distance"
                              class="input"
                              type="number"
                              placeholder="d"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td width="200px">
                            <label class="radio">
                              <input
                                id="2"
                                v-model="coupling"
                                type="radio"
                                value="2"
                              />
                              Disabilitato
                            </label>
                          </td>
                          <td></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="media">
          <div class="box">
            <div class="media-left">
              <strong>Colori</strong>
            </div>
            <div class="media-content">
              <p>
                <small>Icone mezzi</small>
                <br />
              </p>
              <div class="columns">
                <div class="column">
                  <label class="radio"> Mezzo in movimento </label>
                  <compact-picker v-model="bcg0" />
                  <div
                    class="tier has-text-centered"
                    :style="{ 'background-color': bcg0.hex, color: ttt0.hex }"
                  >
                    ICONA
                  </div>
                  <compact-picker v-model="ttt0" />
                  <div class="tier has-text-centered">TESTO</div>
                </div>
                <div class="column">
                  <label class="radio"> 1h - fino ad un ora di sosta </label>
                  <compact-picker v-model="bcg1" />
                  <div
                    class="tier has-text-centered"
                    :style="{ 'background-color': bcg1.hex, color: ttt1.hex }"
                  >
                    ICONA
                  </div>
                  <compact-picker v-model="ttt1" />
                  <div class="tier has-text-centered">TESTO</div>
                </div>
                <div class="column">
                  <label class="radio"> 2h - fino a due ore di sosta </label>
                  <compact-picker v-model="bcg2" />
                  <div
                    class="tier has-text-centered"
                    :style="{ 'background-color': bcg2.hex, color: ttt2.hex }"
                  >
                    ICONA
                  </div>
                  <compact-picker v-model="ttt2" />
                  <div class="tier has-text-centered">TESTO</div>
                </div>
                <div class="column">
                  <label class="radio"> 3h - oltre due ore di sosta </label>
                  <compact-picker v-model="bcg3" />
                  <div
                    class="tier has-text-centered"
                    :style="{ 'background-color': bcg3.hex, color: ttt3.hex }"
                  >
                    ICONA
                  </div>
                  <compact-picker v-model="ttt3" />
                  <div class="tier has-text-centered">TESTO</div>
                </div>
                <div class="column">
                  <label class="radio">
                    oltre a ventiquattro ore di sosta
                  </label>
                  <compact-picker v-model="bcg4" />
                  <div
                    class="tier has-text-centered"
                    :style="{ 'background-color': bcg4.hex, color: ttt4.hex }"
                  >
                    ICONA
                  </div>
                  <compact-picker v-model="ttt4" />
                  <div class="tier has-text-centered">TESTO</div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="has-text-centered">
        <span class="button is-success buttonsize" @click="doInsertPrefs"
          >Salva</span
        >
      </div>
    </template>

    <template v-if="tabNo === 2">
      <div class="columns">
        <div class="column">
          <div class="drivers_scheda_box">
            <div class="field">
              <label class="label">Login Cronotachigrafo</label>
              <div class="control">
                <input
                  v-model="login_kft"
                  class="input"
                  type="text"
                  placeholder="login"
                />
              </div>
            </div>
            <div class="field">
              <label class="label">Password</label>
              <div class="control">
                <input
                  v-model="password_kft"
                  class="input"
                  type="text"
                  placeholder="password"
                />
              </div>
            </div>
          </div>
          <div class="drivers_scheda_bot_box columns">
            <div class="column has-text-centered">
              <span class="button is-info buttonsize" @click="doTestCredenziali"
                >Verifica</span
              >
            </div>
            <div class="column has-text-centered">
              <span
                class="button is-success buttonsize"
                @click="doInsertCredenziali"
                >Salva</span
              >
            </div>
          </div>
        </div>
        <div class="column" />
        <div class="column" />
      </div>
    </template>

    <template v-if="tabNo === 3">
      <div class="columns">
        <div class="column">
          <div class="drivers_scheda_box">
            <div class="field">
              <label class="label">Menù Actia</label>
              <div class="control">
                <div class="field">
                  <label class="checkbox">
                    <input v-model="actia_menu" type="checkbox" />
                    Menù Actia visibile
                  </label>
                </div>
              </div>
            </div>
            <!-- <div class="field">
              <label class="label">Password</label>
              <div class="control">
                <input
                  v-model="password_actia"
                  class="input"
                  type="text"
                  placeholder="password"
                />
              </div>
            </div> -->
          </div>
          <div class="drivers_scheda_bot_box columns">
            <!-- <div class="column has-text-centered">
              <span class="button is-info buttonsize" @click="doResetTokenActia"
                >Reset Actia</span
              >
            </div> -->
            <div class="column has-text-centered">
              <span
                class="button is-success buttonsize"
                @click="
                  doSaveCredenzialiActia(
                    'Modificato il menù di accesso al servizio Actia'
                  )
                "
                >Salva</span
              >
            </div>
          </div>
        </div>
        <div class="column" />
        <div class="column" />
      </div>
    </template>

    <template v-if="tabNo === 4">
      <div id="Feedback">
        <div class="columns">
          <div class="column modal_style">
            <div class="box drivers_scheda_top_box">
              <figure class="image is-32x32">
                <img src="images/feedback.png" />
              </figure>
              <br />
              <p>
                Abbiamo bisogno dei vostri suggerimenti<br /><br />
                Tramite questa pagina di contatto avete la possibilità di
                inviare i vostri suggerimenti e<br />
                le vostre segnalazioni direttamente a chi sta curando la
                realizzazione di questo sito web.<br />
                <br />
                A causa di un malfunzionamento del nostro server di posta alcuni
                vostri messaggi potrebbero<br />
                essere andati perduti. Se non avete avuto risposta ai vostri
                messaggi vi preghiamo di re-inviarli<br />
                Grazie !<br /><br />
                Per assistenza tecnica e commerciale relativa al servizio
                Sovecotech fate esclusivo riferimento<br />
                alla centrale operativa Sovecotech.
                <br />
                <br />
                Grazie
                <br />
              </p>
            </div>
          </div>
          <div class="column modal_style">
            <div class="box drivers_scheda_top_box">
              <div id="emailform">
                <div class="field">
                  <label class="label">Il vostro indirizzo e-mail</label>
                  <div class="control">
                    <input
                      v-model="customerEmail"
                      class="input"
                      type="text"
                      placeholder="e-mail"
                    />
                  </div>
                </div>
                <div id="DR003" class="drivers_scheda_box">
                  <div class="field">
                    <label class="label">La vostra comunicazione</label>
                    <div class="control">
                      <textarea
                        v-model="customerText"
                        class="textarea"
                        placeholder="la vostra communicazione"
                        rows="20"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="drivers_scheda_bot_box columns">
                <div class="column has-text-centered">
                  <span class="button is-danger buttonsize" @click="cancelEmail"
                    >Annulla</span
                  >
                </div>
                <div class="column has-text-centered">
                  <button
                    class="button is-success buttonsize"
                    :disabled="!customerText.length > 0"
                    @click="sendEmail"
                  >
                    Invia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
import VueColor from 'vue-color'
export default {
  name: 'Settings',
  components: {
    VueScrollTable,
    DatePicker,
    'compact-picker': VueColor.Compact,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      customerEmail: '',
      customerText: '',
      bcg0: {},
      bcg1: {},
      bcg2: {},
      bcg3: {},
      bcg4: {},
      ttt0: {},
      ttt1: {},
      ttt2: {},
      ttt3: {},
      ttt4: {},
      tabNo: 0,
      auth: null,
      prefs: null,
      startdata: '',
      enddata: '',
      apiServer: '',
      sostaMin: 5,
      sostaMax: 240,
      storico: 1,
      landing: 1,
      coupling: 2,
      distance: 3,
      actia_menu: false,
      login_actia: '',
      password_actia: '',
      login_kft: '',
      password_kft: '',
      messageScheda: 'Selezionare o creare una password',
      isNewPassword: true,
      selectedRow: null,
      vehiclesOpts: {
        id: 'PW03',
        isResizeable: true,
        isSelectable: true,
        cssContainer: 'password_lc_flex',
        cssHeader: 'vehicles_lh',
        cssBody: 'vehicles_l',
        cssRows: 'vehicles_l',
        order_col: 'targa',
      },
      vehiclesCols: [
        {
          id: 'checked',
          visible: true,
          mousefeedback: true,
          f_type: '*',
          title: '',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: false,
          checkbox: true,
        },
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Flotta veicoli',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
      ],
      vehiclesRows: [],
      vehiclesSelectRows: [],

      vehiclesSelectOpts: {
        id: 'PW04',
        isResizeable: true,
        isSelectable: true,
        cssContainer: 'password_lc_flex',
        cssHeader: 'vehicles_lh',
        cssBody: 'vehicles_l',
        cssRows: 'vehicles_l',
        order_col: 'targa',
      },
      vehiclesSelectCols: [
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Veicoli selezionati',
          width: 200,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
      ],
      passwordOpts: {
        id: 'PW01',
        isResizeable: true,
        isSelectable: true,
        cssContainer: 'password_lc',
        cssHeader: 'password_lh',
        cssBody: 'password_l',
        cssRows: 'password_l',
        order_col: 'login_tmp',
      },
      passwordCols: [
        {
          id: 'login_tmp',
          visible: true,
          f_type: '*',
          title: 'Login',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'inizio',
          visible: true,
          f_type: '*',
          title: 'Inizio',
          alignment_th: '',
          alignment_td: '',
          width: 150,
          elastic: true,
          filter: 'date_reverse_solo_filter',
          order: 0,
          image: false,
        },
        {
          id: 'fine',
          visible: true,
          f_type: '*',
          title: 'Fine',
          alignment_th: '',
          alignment_td: '',
          width: 150,
          elastic: true,
          filter: 'date_reverse_solo_filter',
          order: 0,
          image: false,
        },
      ],
      actiaData: null,
      passwordRows: [],
      passwordSel: {
        login_tmp: '',
        password: '',
        password_chiaro: '',
        nota: '',
        cod: '',
        fine: '',
        inizio: '',
        id: -1,
        vehicles: '',
        filtro_geografico_attivo: false,
        latitudine_centro: null,
        longitudine_centro: null,
        raggio_km: null,
        codici_postali: '',
      },
    }
  },
  beforeRouteLeave(to, from, next) {
    const vm = this
    window.removeEventListener('resize', vm.getWindowHeight)
    next()
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.bcg0.hex = '#68BC00'
    vm.bcg1.hex = '#D33115'
    vm.bcg2.hex = '#D33115'
    vm.bcg3.hex = '#D33115'
    vm.bcg4.hex = '#000000'
    vm.ttt0.hex = '#000000'
    vm.ttt1.hex = '#000000'
    vm.ttt2.hex = '#000000'
    vm.ttt3.hex = '#000000'
    vm.ttt4.hex = '#FFFFFF'
    vm.api_server = vm.getApiServer()
    vm.KFTServer = vm.getKFTServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    this.$nextTick(function () {
      vm.getWindowHeight()
      window.addEventListener('resize', this.getWindowHeight)
      vm.doGetPrefs()
      vm.doGetPasswords()
      vm.doGetVehicles()
      vm.doGetActia()
      vm.password_kft = vm.auth.password_kft
      vm.login_kft = vm.auth.login_kft
      setTimeout(function () {
        vm.isTabActive(1)
      }, 40)
    })
  },
  methods: {
    clearEmail() {
      const vm = this
      vm.customerEmail = ''
      vm.customerText = ''
    },
    cancelEmail() {
      const vm = this
      vm.clearEmail()
    },
    async sendEmail() {
      const vm = this
      if (vm.customerText.length > 0) {
        try {
          const response = await axios.post(
            vm.api_server + 'send_mail',
            {
              customerEmail: vm.customerEmail,
              customerText: vm.customerText,
              customer_name: vm.auth.nome,
            },
            {
              headers: {
                Authorization: vm.auth.tkn,
              },
            }
          )
          if (response.data === true) {
            this.$dialog
              .alert('Email inviata con successo !')
              .then(function (dialog) {})
            vm.cancelEmail()
          } else {
            this.$dialog
              .alert("Email non inviata : ripeteter l'invio !")
              .then(function (dialog) {})
          }
        } catch (e) {
          vm.cancelEmail()
          console.log('error ' + e)
        }
      }
    },

    isTabActive(t) {
      const vm = this
      if (vm.tabNo == t) {
        if (vm.tabNo == 0) {
          let d = new Date()
          vm.startData = d.toISOString()
        }
        return 'is-active'
      } else {
        return ''
      }
    },
    doDeletePassword() {
      const vm = this
      vm.$dialog
        .confirm('Sei sicuro di eliminare questa password')
        .then(function () {
          vm.deletePassword()
        })
        .catch(function () {})
    },
    async deletePassword() {
      const vm = this
      try {
        const response = await axios.delete(
          vm.api_server + 'delete_user_tmp/' + vm.passwordSel.id,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        await vm.doGetPasswords()
        vm.zeroPassword()
        vm.$dialog
          .alert('Password eliminata')
          .then(function () {})
          .catch(function () {})
      } catch (e) {
        console.log('error ' + e)
      }
    },
    zeroPassword() {
      const vm = this
      vm.selectedRow = null
      vm.passwordSel = {
        login_tmp: '',
        password: '',
        password_chiaro: '',
        nota: '',
        cod: (' ' + vm.auth.cod).slice(1),
        fine: '',
        inizio: '',
        id: null,
        vehicles: '',
        filtro_geografico_attivo: false,
        latitudine_centro: null,
        longitudine_centro: null,
        raggio_km: null,
        codici_postali: '',
      }
      vm.setSel(false)
      vm.startdata = ''
      vm.enddata = ''
      vm.messageScheda = 'Selezionare o creare una password'
      ServiceBus.$emit('deselect')
    },
    createPassword() {
      const vm = this
      vm.zeroPassword()
      vm.isNewPassword = true
      vm.messageScheda = 'Creazione di una nuova password'
    },
    cancelEntry() {
      const vm = this
      vm.zeroPassword()
    },
    async saveEntry() {
      const vm = this
      if (vm.getVehiclesSelected()) {
        // Normalizza i codici postali: rimuovi spazi extra e valori vuoti
        if (vm.passwordSel.codici_postali) {
          vm.passwordSel.codici_postali = vm.passwordSel.codici_postali
            .split(',')
            .map((cap) => cap.trim())
            .filter((cap) => cap.length > 0)
            .join(',')
        }

        let d = vm.newDate(vm.startdata)
        d.setHours(0)
        d.setMinutes(0)
        d.setSeconds(0)
        vm.passwordSel.inizio = d.toMysqlString()
        d = vm.newDate(vm.enddata)
        d.setHours(23)
        d.setMinutes(59)
        d.setSeconds(59)
        vm.passwordSel.fine = d.toMysqlString()
        await vm.doSavePassword()
        await vm.doGetPasswords()
        vm.zeroPassword()
      } else {
        vm.$dialog
          .alert(
            'Bisogna selezionare almeno un veicolo per attivare la password'
          )
          .then(function () {})
          .catch(function () {})
      }
    },
    selectItem(item) {
      const vm = this
      item.checked = true
      vm.vehiclesSelectRows.push(item)
    },
    deselectItem(item) {
      const vm = this
      item.checked = false
      let idx = vm.vehiclesSelectRows.indexOf(item)
      vm.vehiclesSelectRows.splice(idx, 1)
    },
    colCheckbox(id, col, item) {
      const vm = this
      if (id === 'PW03' && col.checkbox) {
        item.checked = !item.checked
        if (item.checked) {
          vm.selectItem(item)
        } else {
          vm.deselectItem(item)
        }
      }
    },
    removeSelected() {
      const vm = this
      vm.deselectItem(vm.selectedRow)
      let idx = vm.vehiclesRows.indexOf(vm.selectedRow)
      vm.$set(vm.vehiclesRows, idx, vm.selectedRow)
      vm.selectedRow = null
    },
    colClick(id, col, item) {
      const vm = this
      if (id === 'PW04') {
        vm.selectedRow = item
      }
      if (id === 'PW01') {
        vm.passwordSel = item
        // Normalizza i campi del filtro geografico per password vecchie
        // Converti esplicitamente: solo 1, "1" o true diventano true, tutto il resto false
        vm.passwordSel.filtro_geografico_attivo =
          vm.passwordSel.filtro_geografico_attivo === 1 ||
          vm.passwordSel.filtro_geografico_attivo === '1' ||
          vm.passwordSel.filtro_geografico_attivo === true
        if (
          vm.passwordSel.latitudine_centro === undefined ||
          vm.passwordSel.latitudine_centro === null
        ) {
          vm.passwordSel.latitudine_centro = null
        }
        if (
          vm.passwordSel.longitudine_centro === undefined ||
          vm.passwordSel.longitudine_centro === null
        ) {
          vm.passwordSel.longitudine_centro = null
        }
        if (
          vm.passwordSel.raggio_km === undefined ||
          vm.passwordSel.raggio_km === null
        ) {
          vm.passwordSel.raggio_km = null
        }
        // Normalizza campo codici_postali per password vecchie
        if (
          vm.passwordSel.codici_postali === undefined ||
          vm.passwordSel.codici_postali === null
        ) {
          vm.passwordSel.codici_postali = ''
        }
        vm.setVehiclesSelected()
        vm.isNewPassword = false
        vm.startdata = item.inizio
        vm.enddata = item.fine
        vm.messageScheda = vm.passwordSel.login_tmp
        vm.getWindowHeight(null)
      }
    },
    setSel(value) {
      const vm = this
      if (!value) {
        vm.vehiclesSelectRows = []
      }
      for (let i = 0; i < vm.vehiclesRows.length; i++) {
        if (!vm.vehiclesRows[i].checked && value) {
          vm.vehiclesSelectRows.push(vm.vehiclesRows[i])
        }
        vm.vehiclesRows[i].checked = value
        vm.$set(vm.vehiclesRows, i, vm.vehiclesRows[i])
      }
    },
    setVehiclesSelected() {
      const vm = this
      let i
      vm.vehiclesSelectRows = []

      if (vm.passwordSel.vehicles.length == 0) {
        for (i = 0; i < vm.vehiclesRows.length; i++) {
          vm.vehiclesRows[i].checked = false
          vm.$set(vm.vehiclesRows, i, vm.vehiclesRows[i])
        }
        return
      }
      let a = vm.passwordSel.vehicles.split('|')
      let idx
      for (i = 0; i < vm.vehiclesRows.length; i++) {
        idx = a.findIndex(function (ele) {
          return ele == vm.vehiclesRows[i].cod
        })
        if (idx >= 0) {
          vm.vehiclesRows[i].checked = true
          vm.$set(vm.vehiclesRows, i, vm.vehiclesRows[i])
          vm.vehiclesSelectRows.push(vm.vehiclesRows[i])
        } else {
          vm.vehiclesRows[i].checked = false
          vm.$set(vm.vehiclesRows, i, vm.vehiclesRows[i])
        }
      }
      vm.getWindowHeight(null)
    },
    getVehiclesSelected() {
      const vm = this
      vm.passwordSel.vehicles = ''
      let sep = ''
      for (let i = 0; i < vm.vehiclesRows.length; i++) {
        if (vm.vehiclesRows[i].checked) {
          vm.passwordSel.vehicles += sep
          vm.passwordSel.vehicles += vm.vehiclesRows[i].cod
          sep = '|'
        }
      }
      return vm.passwordSel.vehicles.length > 0
    },
    async doSavePassword() {
      const vm = this
      try {
        vm.passwordSel.login_base = vm.auth.login
        const response = await axios.post(
          vm.api_server + 'replace_users_tmp',
          vm.passwordSel,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.setSel(false)
        if (vm.isNewPassword) {
          vm.messageScheda = 'Creato la nuova password con successo'
        } else {
          vm.messageScheda = 'Salvato le modifiche alla password'
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doSaveVehiclesPassword(password, cod) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_new_user_tmp_vehicles',
          { password, cod },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doDeleteVehiclesPassword(password) {
      const vm = this
      try {
        const response = await axios.delete(
          vm.api_server + 'delete_user_tmp_vehicles/' + password,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doGetPasswords() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_users_tmp/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data) {
            vm.passwordRows = response.data
          }
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doGetPrefs() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_prefs/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data) {
            vm.prefs = response.data
            vm.coupling =
              response.data.coupling === undefined ? 2 : response.data.coupling
            vm.distance = response.data.distance
            vm.landing = response.data.landing
            vm.storico = response.data.storico
            vm.sostaMax = response.data.sosta_max
            vm.sostaMin = response.data.sosta_min
            vm.bcg0.hex = response.data.bcg0
            vm.bcg1.hex = response.data.bcg1
            vm.bcg2.hex = response.data.bcg2
            vm.bcg3.hex = response.data.bcg3
            vm.bcg4.hex = response.data.bcg4
            vm.ttt0.hex = response.data.ttt0
            vm.ttt1.hex = response.data.ttt1
            vm.ttt2.hex = response.data.ttt2
            vm.ttt3.hex = response.data.ttt3
            vm.ttt4.hex = response.data.ttt4
            vm.$localStorage.set('prefs', JSON.stringify(vm.prefs))
          } else {
            vm.sostaMin = 5
            vm.sostaMax = 240
            vm.storico = 1
          }
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doInsertPrefs() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_prefs',
          {
            cod: vm.auth.cod,
            sosta_min: vm.sostaMin,
            sosta_max: vm.sostaMax,
            storico: vm.storico,
            landing: vm.landing,
            coupling: vm.coupling,
            distance: vm.distance,
            bcg0: vm.bcg0.hex,
            bcg1: vm.bcg1.hex,
            bcg2: vm.bcg2.hex,
            bcg3: vm.bcg3.hex,
            bcg4: vm.bcg4.hex,
            ttt0: vm.ttt0.hex,
            ttt1: vm.ttt1.hex,
            ttt2: vm.ttt2.hex,
            ttt3: vm.ttt3.hex,
            ttt4: vm.ttt4.hex,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.$dialog
          .alert('Preferenze salvate')
          .then(function () {
            vm.doGetPrefs()
          })
          .catch(function () {})
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doTestCredenziali() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'loginkft',
          {
            group: 'SV',
            password: vm.password_kft,
            name: vm.login_kft,
            token: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response.data.login === 'ok') {
          this.$dialog
            .alert('OK Credenziali verificate con successo')
            .then(function (dialog) {})
        } else {
          this.$dialog
            .alert('Controllare login o password')
            .then(function (dialog) {})
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doGetVehicles() {
      const vm = this
      vm.vehiclesRows = await ServiceBus._doGetVehicles()
      for (let i = 0; i < vm.vehiclesRows.length; i++) {
        vm.vehiclesRows[i].checked = false
      }
    },

    async doInsertCredenziali(mssg) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_kft_credenziali',
          {
            cod_sv: vm.auth.cod,
            password_kft: vm.password_kft,
            login_kft: vm.login_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.auth.password_kft = vm.password_kft
        vm.auth.login_kft = vm.login_kft
        this.$dialog
          .alert('Credenziali salvate con successo')
          .then(function (dialog) {})
      } catch (e) {
        this.$dialog
          .alert('Problema nel salvare le credenziali')
          .then(function (dialog) {})
        console.log('error ' + e)
      }
    },

    async doResetTokenActia() {
      const vm = this
      await vm.doSaveCredenzialiActia(
        "Effettuato il reset per l'accesso al servizio Actia"
      )
    },

    async doSaveCredenzialiActia(mssg) {
      const vm = this

      if (vm.actia_menu) {
        vm.login_actia = 'AAA'
        vm.password_actia = 'AAA'
        vm.auth.flag_actia = true
      } else {
        vm.login_actia = ''
        vm.password_actia = ''
        vm.auth.flag_actia = false
      }

      vm.actiaData = {}
      vm.actiaData.cod_utente = vm.auth.cod
      vm.actiaData.login = vm.login_actia
      vm.actiaData.password = vm.password_actia
      vm.actiaData.token = ''
      vm.actiaData.ts = 0

      await ServiceBus._doInsertCredenzialiActia(vm.actiaData)
      vm.$dialog
        .alert(mssg)
        .then(function () {})
        .catch(function () {})
    },

    async doGetActia() {
      const vm = this
      vm.actiaData = await ServiceBus._getActia()
      if (vm.actiaData) {
        vm.login_actia = vm.actiaData.login
        vm.password_actia = vm.actiaData.password
        vm.actia_menu =
          vm.login_actia.length > 0 && vm.password_actia.length > 0
      } else {
        vm.actia_menu = false
      }
    },

    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      let a = document.getElementById(vm.passwordOpts.id + 'bw')
      if (a !== null && a !== undefined) {
        a.setAttribute('style', 'height:' + (vm.windowHeight / 3 - 72) + 'px')
      }
      let b = document.getElementById('PW02')
      if (b !== undefined && b !== null) {
        b.setAttribute('style', 'height:' + (vm.windowHeight / 3 - 10) + 'px')
      }
      let c = document.getElementById(vm.vehiclesOpts.id + 'bw')
      if (c !== undefined && c !== null) {
        c.setAttribute('style', 'height:' + (vm.windowHeight - 245) + 'px')
      }
      let d = document.getElementById(vm.vehiclesSelectOpts.id + 'bw')
      if (d !== undefined && d !== null) {
        d.setAttribute('style', 'height:' + (vm.windowHeight - 245) + 'px')
      }
    },
  },
}
</script>
